import * as React from 'react';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import '../../../types/product.js';
import '../../../context/ProductContext.js';
import { useCmsData } from '../../../context/CmsContext.js';
import { ProductDetailDisclaimer } from './ProductDetailDisclaimer.js';

const ProductDetailDisclaimerContainer = ({ className  })=>{
    const { disclaimer  } = useCmsData();
    if (!disclaimer) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductDetailDisclaimer, {
        className: className,
        disclaimer: disclaimer
    });
};

export { ProductDetailDisclaimerContainer };
//# sourceMappingURL=ProductDetailDisclaimerContainer.js.map
